import React, { createContext, useContext, useState, ReactNode } from 'react'

interface DropdownContextType {
  showDropdown: (content: ReactNode) => void
  hideDropdown: () => void
  content: ReactNode | null
  visible: boolean
}

const DropdownContext = createContext<DropdownContextType>({
  showDropdown: () => {},
  hideDropdown: () => {},
  content: null,
  visible: false,
})

export const DropdownProvider = ({ children }: { children: ReactNode }) => {
  const [content, setContent] = useState<ReactNode | null>(null)
  const [visible, setVisible] = useState(false)

  const showDropdown = (dropdownContent: ReactNode) => {
    setContent(dropdownContent)
    setVisible(true)
  }

  const hideDropdown = () => {
    setContent(null)
    setVisible(false)
  }

  return (
    <DropdownContext.Provider
      value={{ showDropdown, hideDropdown, content, visible }}
    >
      {children}
    </DropdownContext.Provider>
  )
}

export const useDropdown = () => useContext(DropdownContext)
